// import Link from 'next/link';
// Libraries
import { Avatar, AvatarGroup, Box, Button, Center, chakra, Flex, Text } from "@chakra-ui/react";
import { useEmblaCarousel } from "embla-carousel/react";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { Fragment } from "react";
import { RiArrowRightUpLine } from "react-icons/ri";
// Recoil
import { useSetRecoilState } from "recoil";
import { sliceAndReturn } from "../../Helpers/HelpfulFunctions";
import { activeClass } from "../../State";
import { NetworkError } from "../UI/Error";
import Empty from "../UI/Errors/Empty";
import Loader from "../UI/Loader";
// Components
import SwipeCards3 from "../UI/SwipeCards3";
// import ScheduledMeetings from "./ScheduledMeetings";

interface Props {
  classesData: any;
  isLoading: boolean;
  error: any;
  refetch?: any;
}

export const Item2 = (item: any) => {
  const classData = item && item.class;

  // mAX NUMBER OF STUDENTS AVATAR TO SHOW
  const allStudents = sliceAndReturn(classData && classData.students, 3);

  // Next router
  const router = useRouter();

  // Recoil
  const setActiveClass = useSetRecoilState(activeClass);

  return (
    <Flex w="100%" flexDir="column" h={{ base: "100%", md: "70vh" }}>
      <Box
        mx={4}
        bg="gray.100"
        minH="20vh"
        h="100%"
        my={4}
        overflow="hidden"
        pos="relative"
        borderRadius="6px"
        __css={{ img: { userSelect: "none", pointerEvents: "none" } }}>
        {classData.avatar && <Image src={classData.avatar} layout="fill" objectFit="cover" objectPosition="center" />}
        {!classData.avatar && (
          <Flex h="100%">
            <chakra.svg m="auto" w="68px" h="68px" color="gray.300" fill="currentColor" viewBox="0 0 328 328">
              <path
                fillRule="evenodd"
                clip-rule="evenodd"
                d="M164 328C254.575 328 328 254.575 328 164C328 73.4253 254.575 0 164 0C73.4253 0 0 73.4253 0 164C0 254.575 73.4253 328 164 328ZM241.026 162.758V162.761L241.029 162.758V238.545H165.242L165.239 238.545C123.383 238.545 89.4521 204.614 89.4521 162.758C89.4521 120.902 123.383 86.9709 165.239 86.9709C207.095 86.9709 241.026 120.902 241.026 162.758Z"
              />
            </chakra.svg>
          </Flex>
        )}
      </Box>
      <Flex px={{ base: 6, md: 10 }}>
        {/* author avatar */}
        {/* <HStack my="auto" color="gray.400" fontWeight="700" spacing="2">
          <Avatar
            borderRadius="lg"
            width={{ base: "40px", md: "48px" }}
            height={{ base: "40px", md: "48px" }}
            fontWeight={700}
            name={classData && classData.created_by && classData.created_by.full_name}
            src={classData && classData.created_by && classData?.created_by?.avatar}
            mr={2}
          />
          <Text as="span" fontSize="lg" color="gray.500" isTruncated w={{ base: "93px", md: "100%" }}>
            {classData && classData.created_by && classData.created_by.full_name}
          </Text>
        </HStack> */}
        {/* xOpen class arrow */}
        <Button
          p={0}
          color="gray.400"
          fontSize="3xl"
          variant="ghost"
          borderRadius="lg"
          ml="auto"
          onClick={(e: any) => {
            router.push(`/classes/enrolled/${classData._id}`);
            e.stopPropagation();
            setActiveClass({
              active_class_id: classData._id,
              active_class_name: classData.class_name,
            });
          }}>
          <RiArrowRightUpLine />
        </Button>
      </Flex>

      <Box
        // onDoubleClick={(e: any) => {
        //   router.push(`/classes/enrolled/${classData._id}`)
        //   e.stopPropagation();
        //   setActiveClass({
        //     active_class_id: classData._id,
        //     active_class_name: classData.class_name
        //   })
        // }}
        // pt={10}
        pb={10}
        px={{ base: 6, md: 10 }}
        mt="auto"
        cursor="pointer">
        <Box
          onClick={(e: any) => {
            router.push(`/classes/enrolled/${classData._id}`);
            e.stopPropagation();
            setActiveClass({
              active_class_id: classData._id,
              active_class_name: classData.class_name,
            });
          }}
          marginBottom={6}>
          <Text color="blue.500" fontWeight="900" fontSize={{ base: "xl", md: "2xl" }}>
            {(classData && classData.class_name) || ""}
          </Text>
        </Box>

        <Flex alignItems="center">
          {classData && classData.students && classData.students.length > 0 && (
            <>
              <AvatarGroup my="auto" mr={2} size="sm" max={2}>
                {allStudents &&
                  allStudents.map((studentsData) => {
                    const { student } = studentsData;

                    return <Avatar key={student._id} fontWeight="bold" name={student && student.full_name} w="40px" h="40px" />;
                  })}
              </AvatarGroup>
            </>
          )}
          <Text fontSize="md" color="gray.500" fontWeight="700" ml="auto">
            {classData && classData.lessons && classData.lessons.length} Lessons
          </Text>

          {/* <Text fontSize="md" color="gray.400" fontWeight="700">
            {classData && classData.no_of_students} {""}
            {classData && classData.no_of_students === 1 ? "Student" : "Students"}
          </Text> */}
        </Flex>
      </Box>
    </Flex>
  );
};

const EnrolledClasses = ({ classesData, isLoading, error }: Props) => {
  // Display content for each class

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
  });

  React.useEffect(() => {
    if (emblaApi) {
      // Embla API is ready
    }
  }, [emblaApi]);

  // if data is loading display a loader
  if (isLoading) {
    return (
      <Center h="88vh">
        <Loader />
      </Center>
    );
  }

  if (error) {
    <Center h="100%">
      <NetworkError />
    </Center>;
  }

  // const reversedClasses = [...classesData].reverse();

  // Display content classes
  return (
    <Flex pt={{ base: 4, md: 16 }} flexDir="column" overflow="hidden" h={{ base: "calc(100vh - 120px)", lg: "100vh" }}>
      {/* <ScheduledMeetings /> */}
      <Box px={{ base: 6, md: 16 }} h={{ base: "calc(60vh + 100px)", lg: "calc(80vh + 120px)" }}>
        {classesData && classesData.length > 0 ? (
          <Fragment>
            <Text fontSize="md" fontWeight="700" mb={{ base: 4, md: 4 }} textColor="gray.500">
              {classesData && classesData.length === 1 && <> Showing {classesData && classesData.length} class</>}

              {classesData && classesData.length > 1 && <> Showing {classesData && classesData.length} classes</>}
            </Text>
            {/* <SwipeCards1 data={classesData && classesData.length > 0 ? classesData : []} renderItem={Item2} /> */}

            {/* <Box width="100%" height={{ base: "65vh", lg: "74vh" }}>
              <SwipeCards2 component={Item} data={classesData && classesData.length > 0 ? classesData : []} />
            </Box> */}

            <SwipeCards3 data={classesData && classesData.length > 0 ? classesData : []} renderItem={Item2} height="70vh" />
          </Fragment>
        ) : (
          <Center>
            {/* <Text fontSize="md" fontWeight="bold">You're not enrolled to any class</Text> */}
            <Empty type="class" title="No Classes" subtitle="You're not enrolled to any class" />
          </Center>
        )}
      </Box>
    </Flex>
  );
};

export default EnrolledClasses;
